import * as React from 'react';

import { useCountDown, usePhoneValue, useSendVerificationCode, useVerificationStep, useVerifyValue } from './utils';
import { EPhoneVerificationStep } from './constants';
import { PhoneField, VerifyField } from '../../../../components/Recommendations';

export interface IPhoneVerificationContainerProps {
  submitText: string;

  onSubmit(): void;
}

export const PhoneVerificationContainer: React.FC<IPhoneVerificationContainerProps> = ({ onSubmit, submitText }) => {
  const { phone, onChange: onChangePhone, isValid: isPhoneValid } = usePhoneValue();
  const { seconds: countDown, start: startCountDown } = useCountDown();
  const { value: verificationCode, onChange: onChangeVerify, isValid: isVerifyValid } = useVerifyValue('');
  const { gotToPhoneStep, goToVerificationStep, step } = useVerificationStep();
  const {
    isFetching,
    error: requestError,
    sendVerificationCode,
    sendVerificationSms,
  } = useSendVerificationCode({
    verificationCode,
    phone,
    startCountDown,
    onVerifySuccess: onSubmit,
    onSendSmsSuccess: goToVerificationStep,
  });

  if (step === EPhoneVerificationStep.PHONE) {
    return (
      <PhoneField
        error={requestError}
        fetching={isFetching}
        value={phone}
        onChange={onChangePhone}
        isValid={isPhoneValid}
        onSubmit={sendVerificationSms}
      />
    );
  }

  return (
    <VerifyField
      fetching={isFetching}
      seconds={countDown}
      restart={sendVerificationSms}
      phone={phone}
      value={verificationCode}
      error={requestError}
      isValid={isVerifyValid}
      onChange={onChangeVerify}
      onSubmit={sendVerificationCode}
      onChangePhone={gotToPhoneStep}
      submitText={submitText}
    />
  );
};

PhoneVerificationContainer.displayName = 'PhoneVerificationContainer';
